import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["panel", "input", "clearButton", "searchButton"]

    connect() {
        if (this.inputTarget.value.trim() !== "") this.open()
        this.toggleClearButton()

        this.boundOutside = this.onClickOutside.bind(this)
        window.addEventListener("click", this.boundOutside)
    }

    disconnect() {
        window.removeEventListener("click", this.boundOutside)
    }

    onTriggerClick(event) {
        if (!this.isOpen()) {
            event.preventDefault()
            this.open()
            event.stopPropagation()
            this.inputTarget.focus()
            return
        }

        if (this.inputTarget.value.trim() === "") {
            event.preventDefault()
            this.inputTarget.focus()
        }
    }

    submitFromInput(event) {
        if (this.inputTarget.value.trim() === "") event.preventDefault()
    }

    toggleClearButton() {
        if (!this.isOpen() || this.inputTarget.value.trim() === "") {
            this.clearButtonTarget.classList.add("d-none")
        } else {
            this.clearButtonTarget.classList.remove("d-none")
        }
    }

    clearAndClose() {
        this.inputTarget.value = ""
        this.close()
        this.toggleClearButton()
        this.searchButtonTarget.focus()
    }

    onClickOutside(e) {
        if (this.isOpen() && !this.element.contains(e.target)) {
            this.close()
        }
    }

    open() {
        if (this.hasPanelTarget) {
            this.panelTarget.classList.add("is-open")
            this.panelTarget.setAttribute("aria-hidden", "false")
            this.searchButtonTarget.setAttribute("aria-expanded", "true")
        }
    }

    close() {
        if (this.hasPanelTarget) {
            this.panelTarget.classList.remove("is-open")
            this.panelTarget.setAttribute("aria-hidden", "true")
            this.searchButtonTarget.setAttribute("aria-expanded", "false")
        }
    }

    isOpen() {
        return this.hasPanelTarget
            ? this.panelTarget.classList.contains("is-open")
            : false
    }
}
